export const ApiKey = 'Document Library'